// import React from "react";
// import "./About.css";

// // Replace these with real TerraWeb photos when ready.
// // Team/hero shots are placeholders pulled from Unsplash; director photos are
// // placeholder headshots from pravatar. Swap the `src` values for real assets
// // (e.g. import from "./assets/...") without touching any markup or CSS.
// const IMAGES = {
//   heroTeam: "https://source.unsplash.com/1600x1000/?african,business,team",
//   storyTeam: "https://source.unsplash.com/1000x750/?team,meeting,startup",
// };

// const journey = [
//   {
//     year: "2022",
//     title: "Formation",
//     text: "Five individuals with a shared vision came together to form TerraWeb.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     year: "2022",
//     title: "Concept & Research",
//     text: "We explored real challenges and designed solutions around data and connectivity.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.44 1 1.16 1 1.94V17h6v-.36c0-.78.4-1.5 1-1.94A7 7 0 0 0 12 2Z"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     year: "2023",
//     title: "Prototype",
//     text: "Our first prototype was built and tested with close partners and stakeholders.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="m16 18 6-6-6-6M8 6l-6 6 6 6"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     year: "2023",
//     title: "First Engagements",
//     text: "We engaged cooperatives and organizations in agriculture.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     year: "2024",
//     title: "Partnerships",
//     text: "Strategic partnerships were formed to scale our impact.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="M18 8a3 3 0 1 0-2.83-4H15a3 3 0 0 0 0 6h.17A3 3 0 0 0 18 8ZM6 16a3 3 0 1 0 2.83 4H9a3 3 0 0 0 0-6h-.17A3 3 0 0 0 6 16ZM8 9l8 4"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
//   {
//     year: "Today",
//     title: "Growing Impact",
//     text: "We continue to innovate, connect and empower more organizations.",
//     icon: (
//       <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path
//           d="M3 17 9 11 13 15 21 7M21 7h-6M21 7v6"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </svg>
//     ),
//   },
// ];

// const directors = [
//   {
//     name: "Eric Ssentamu",
//     role: "Director & Co-Founder",
//     bio: "Visionary leader with expertise in technology, systems design and organizational strategy.",
//     img: "https://i.pravatar.cc/300?img=12",
//   },
//   {
//     name: "Ssempijja Moses",
//     role: "Director & Co-Founder",
//     bio: "Data and enterprise solutions expert focused on building scalable and impactful systems.",
//     img: "https://i.pravatar.cc/300?img=13",
//   },
//   {
//     name: "Turyamureeba Brian",
//     role: "Director & Co-Founder",
//     bio: "Operations and project management professional passionate about efficiency and execution.",
//     img: "https://i.pravatar.cc/300?img=14",
//   },
//   {
//     name: "Nuwamanya Ivan",
//     role: "Director & Co-Founder",
//     bio: "Technology innovator with a strong background in cloud solutions and development.",
//     img: "https://i.pravatar.cc/300?img=15",
//   },
//   {
//     name: "Namayanja Ivan",
//     role: "Director & Co-Founder",
//     bio: "Business development and partnerships specialist with a drive for sustainable growth.",
//     img: "https://i.pravatar.cc/300?img=16",
//   },
// ];

// export default function About() {
//   return (
//     <div className="about-page">
//       {/* ===== HERO ===== */}
//       <section
//         className="hero"
//         style={{ backgroundImage: `url(${IMAGES.heroTeam})` }}
//       >
//         <div className="hero__overlay" />
//         <div className="hero__inner">
//           <p className="eyebrow eyebrow--light">About Us</p>
//           <h1 className="hero__title">
//             Building Connected
//             <br />
//             Digital Infrastructure
//             <br />
//             for a Better Tomorrow
//           </h1>
//           <p className="hero__text">
//             TerraWeb is a data-enabled organization committed to connecting
//             people, systems and opportunities through technology,
//             communication, enterprise solutions and cloud innovations.
//           </p>
//           <a href="#our-story" className="btn btn--primary">
//             Our Story
//             <svg
//               className="btn__icon"
//               viewBox="0 0 24 24"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M5 12h14M13 6l6 6-6 6"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </a>
//         </div>
//       </section>

//       {/* ===== OUR STORY ===== */}
//       <section className="story" id="our-story">
//         <div className="story__grid">
//           <div className="story__text">
//             <p className="eyebrow">Our Story</p>
//             <h2 className="section-title">The Beginning of TerraWeb</h2>

//             <p>
//               TerraWeb was born from a simple but powerful realization:
//               information has the power to transform lives.
//             </p>
//             <p>
//               In the early days, five young visionaries came together with a
//               shared passion for technology and a desire to solve real
//               challenges faced by organizations and communities. We saw the
//               gaps in data management, communication, and operational
//               efficiency&mdash;especially within agricultural cooperatives
//               and rural enterprises.
//             </p>
//             <p>
//               We started small, with big dreams and a commitment to build
//               digital solutions that are reliable, affordable, and impactful.
//               Today, TerraWeb continues to grow, innovate, and partner with
//               organizations to build a more connected and empowered world.
//             </p>
//           </div>

//           <div className="story__media">
//             <img src={IMAGES.storyTeam} alt="The TerraWeb founding team" />
//             <p className="story__caption">
//               The TerraWeb founding team during our early formation stage.
//               <br />
//               <em>Great things start with great conversations.</em>
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ===== OUR JOURNEY ===== */}
//       <section className="journey">
//         <p className="eyebrow eyebrow--center">Our Journey</p>

//         <div className="journey__timeline">
//           <div className="journey__line" />
//           {journey.map((step, i) => (
//             <div className="journey__step" key={i}>
//               <span className="journey__icon">{step.icon}</span>
//               <span className="journey__year">{step.year}</span>
//               <h3 className="journey__title">{step.title}</h3>
//               <p className="journey__text">{step.text}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ===== DIRECTORS ===== */}
//       <section className="directors">
//         <p className="eyebrow">Meet Our Directors</p>

//         <div className="directors__grid">
//           {directors.map((d) => (
//             <div className="director-card" key={d.name}>
//               <img src={d.img} alt={d.name} className="director-card__photo" />
//               <h3 className="director-card__name">{d.name}</h3>
//               <p className="director-card__role">{d.role}</p>
//               <p className="director-card__bio">{d.bio}</p>
//               <div className="director-card__social">
//                 <a href="#" aria-label={`${d.name} on LinkedIn`}>
//                   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path
//                       d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.64h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.7c0-1.36-.02-3.1-1.89-3.1-1.9 0-2.19 1.48-2.19 3v5.8h-4V9Z"
//                       fill="currentColor"
//                     />
//                   </svg>
//                 </a>
//                 <a href="#" aria-label={`Email ${d.name}`}>
//                   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path
//                       d="M3 6h18v12H3V6Zm0 0 9 7 9-7"
//                       stroke="currentColor"
//                       strokeWidth="1.8"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="directors__footer">
//           <a href="#" className="btn btn--outline">
//             Our Leadership Philosophy
//           </a>
//         </div>
//       </section>

//       {/* PART 2 CONTINUES BELOW — paste next section's JSX here */}
//     </div>
//   );
// }


import React from "react";
import "./About.css";

// Replace these with real TerraWeb photos when ready.
// Team/hero shots are placeholders pulled from Unsplash; director photos are
// placeholder headshots from pravatar. Swap the `src` values for real assets
// (e.g. import from "./assets/...") without touching any markup or CSS.
const IMAGES = {
  heroTeam: "/img/team.png",
  storyTeam: "/img/storyteam.png",
};

// Gallery photos — swap for real event photos when available.
const moments = [
  {
    caption: "Team Brainstorming",
    src: "/img/brains.png",
  },
  {
    caption: "Community Engagement",
    src: "/img/training.png",
  },
  {
    caption: "Cooperative Training",
    src: "/img/community.png",
  },
  {
    caption: "Field Visit",
    src: "/img/training.png",
  },
  {
    caption: "Team Meeting",
    src: "/img/meeting.png",
  },
  {
    caption: "Presentation Session",
    src: "/img/community.png",
  },
];

const milestones = [
  { year: "2022", text: "TerraWeb is officially founded" },
  { year: "2022", text: "First prototype developed" },
  { year: "2023", text: "First cooperative onboarded" },
  { year: "2023", text: "First strategic partnership signed" },
  { year: "2024", text: "Expansion of services" },
  { year: "2024", text: "Continued growth & innovation" },
];

const partners = [
  // {
  //   name: "NUCAFE (Uganda)",
  //   blurb:
  //     "Working together to empower coffee cooperatives through data and digital solutions.",
  //   accent: "#c0392b",
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         d="M4 9h13a3 3 0 0 1 0 6h-1M4 9v7a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-1M6 4c.5 1 .5 2-.5 3M10 4c.5 1 .5 2-.5 3"
  //         stroke="currentColor"
  //         strokeWidth="1.7"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   name: "Milk Uganda",
  //   blurb: "Collaborating to enhance dairy value chains through technology.",
  //   accent: "#2e86c1",
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         d="M9 2h6l1 4-1 2v11a3 3 0 0 1-3 3v0a3 3 0 0 1-3-3V8L8 6l1-4Z"
  //         stroke="currentColor"
  //         strokeWidth="1.7"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  // {
  //   name: "UCDA",
  //   blurb:
  //     "Supporting cooperative societies with digital transformation initiatives.",
  //   accent: "#3a9c52",
  //   icon: (
  //     <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  //       <path
  //         d="m12 2 7 3v6c0 4.7-3 8.4-7 11-4-2.6-7-6.3-7-11V5l7-3Z"
  //         stroke="currentColor"
  //         strokeWidth="1.7"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
];

const certificates = [
  { title: "Certificate of Registration", year: "2022" },
  { title: "Certificate of Incorporation", year: "2022" },
  { title: "Tax Compliance Certificate", year: "2023" },
];

const journey = [
  {
    year: "October 2020",
    title: "Formation",
    text: "Five individuals with a shared vision came together to form TerraWeb.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    year: "2021 - 2022",
    title: "Concept & Research",
    text: "We explored real challenges and designed solutions around data and connectivity.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.44 1 1.16 1 1.94V17h6v-.36c0-.78.4-1.5 1-1.94A7 7 0 0 0 12 2Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    year: "2023",
    title: "Prototype",
    text: "Our first prototype was built and tested with close partners and stakeholders.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m16 18 6-6-6-6M8 6l-6 6 6 6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    year: "2023",
    title: "First Engagements",
    text: "We engaged cooperatives and organizations in agriculture.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    year: "2025",
    title: "Partnerships",
    text: "Strategic partnerships were formed to scale our impact.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 8a3 3 0 1 0-2.83-4H15a3 3 0 0 0 0 6h.17A3 3 0 0 0 18 8ZM6 16a3 3 0 1 0 2.83 4H9a3 3 0 0 0 0-6h-.17A3 3 0 0 0 6 16ZM8 9l8 4"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    year: "Today",
    title: "Growing Impact",
    text: "We continue to innovate, connect and empower more organizations.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 17 9 11 13 15 21 7M21 7h-6M21 7v6"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const directors = [
  {
    name: "Dennis Mburu",
    role: "Director & Co-Founder",
    bio: "Visionary leader with expertise in technology, systems design and organizational strategy.",
    img: "/img/director.jpg",
  },
  {
    name: "Martin M. Chege",
    role: "Director & Founder",
    bio: "Data and enterprise solutions expert focused on building scalable and impactful systems.",
    img: "/img/cofounder.jpg",
  },
  {
    name: "Abijah Macharia",
    role: "Director & Co-Founder",
    bio: "Operations and project management professional passionate about efficiency and execution.",
    img: "/img/operationsmanager.jpg",
  },
  {
    name: "Rose Waithera",
    role: "Director & Co-Founder",
    bio: "Technology innovator with a strong background in cloud solutions and development.",
    img: "/img/techinnovator.png",
  },
  {
    name: "Jemimah Njeru",
    role: "Director & Co-Founder",
    bio: "Business development and partnerships specialist with a drive for sustainable growth.",
    img: "/img/businessmanager.png",
  },
];

export default function About() {
  return (
    <div className="about-page">
      {/* ===== HERO ===== */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${IMAGES.heroTeam})` }}
      >
        <div className="hero__overlay" />
        <div className="hero__inner">
          <h1 className="eyebrow eyebrow--light">About Us</h1>
          <h1 className="hero__title">
            Building Connected
            <br />
            Digital Infrastructure
            <br />
            for a Better Tomorrow
          </h1>
          <h3 className="hero__text">
            TerraWeb is a data-enabled organization committed to connecting
            people, systems and opportunities through technology,
            communication, enterprise solutions and cloud innovations.
          </h3>
          <a href="#our-story" className="btn btn--primary">
            Our Story
            <svg
              className="btn__icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12h14M13 6l6 6-6 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </section>

      {/* ===== OUR STORY ===== */}
      <section className="story" id="our-story">
        <div className="story__grid">
          <div className="story__text">
            <p className="eyebrow">Our Story</p>
            <h2 className="section-title">The Beginning of TerraWeb</h2>

            <p>
              TerraWeb was born from a simple but powerful realization:
              information has the power to transform lives.
            </p>
            <p>
              In the early days, five young visionaries came together with a
              shared passion for technology and a desire to solve real
              challenges faced by organizations and communities. We saw the
              gaps in data management, communication, and operational
              efficiency&mdash;especially within agricultural cooperatives
              and rural enterprises.
            </p>
            <p>
              We started small, with big dreams and a commitment to build
              digital solutions that are reliable, affordable, and impactful.
              Today, TerraWeb continues to grow, innovate, and partner with
              organizations to build a more connected and empowered world.
            </p>
          </div>

          {/* <div className="story__media">
            <img src={IMAGES.storyTeam} alt="The TerraWeb founding team" />
            <p className="story__caption">
              The TerraWeb founding team during our early formation stage.
              <br />
              <em>Great things start with great conversations.</em>
            </p>
          </div> */}
        </div>
      </section>

      {/* ===== OUR JOURNEY ===== */}
      <section className="journey">
        <p className="eyebrow eyebrow--center">Our Journey</p>

        <div className="journey__timeline">
          <div className="journey__line" />
          {journey.map((step, i) => (
            <div className="journey__step" key={i}>
              <span className="journey__icon">{step.icon}</span>
              <span className="journey__year">{step.year}</span>
              <h3 className="journey__title">{step.title}</h3>
              <p className="journey__text">{step.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== DIRECTORS ===== */}
      <section className="directors">
        <p className="eyebrow">Meet Our Directors</p>

        <div className="directors__grid">
          {directors.map((d) => (
            <div className="director-card" key={d.name}>
              <img src={d.img} alt={d.name} className="director-card__photo" />
              <h3 className="director-card__name">{d.name}</h3>
              <p className="director-card__role">{d.role}</p>
              <p className="director-card__bio">{d.bio}</p>
              <div className="director-card__social">
                <a href="#" aria-label={`${d.name} on LinkedIn`}>
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.64h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.7c0-1.36-.02-3.1-1.89-3.1-1.9 0-2.19 1.48-2.19 3v5.8h-4V9Z"
                      fill="currentColor"
                    />
                  </svg>
                </a>
                <a href="#" aria-label={`Email ${d.name}`}>
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3 6h18v12H3V6Zm0 0 9 7 9-7"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="directors__footer">
          <a href="/contactus" className="btn btn--outline">
            Our Leadership Philosophy
          </a>
        </div>
      </section>

      {/* ===== MILESTONES / PARTNERS / CERTIFICATES ===== */}
      <section className="highlights">
        <div className="highlights__grid">
          {/* <div className="panel">
            <h3 className="panel__title">Key Milestones</h3>
            <ul className="milestone-list">
              {milestones.map((m, i) => (
                <li key={i}>
                  <span className="milestone-list__year">{m.year}</span>
                  <span className="milestone-list__text">{m.text}</span>
                </li>
              ))}
            </ul>
            <a href="#" className="panel__link">
              View Full Timeline
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div> */}

          <div className="panelPartner">
            <h3 className="panel__title">Partnerships</h3>
     <a href="https://terraweb.africa/contactus" className="panel__link">
              Be among our partners
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>

            <div className="partner-list">
              {partners?.map((p) => (
                <div className="partner-card" key={p.name}>
                  <span
                    className="partner-card__icon"
                    style={{ color: p.accent, borderColor: p.accent }}
                  >
                    {p.icon}
                  </span>
                  <p className="partner-card__name">{p.name}</p>
                  <p className="partner-card__blurb">{p.blurb}</p>
                </div>
              ))}
            </div>
       
          </div>

          <div className="panel">
            <h3 className="panel__title">Certificates &amp; Recognition</h3>
            <div className="cert-list">
              {certificates.map((c) => (
                <div className="cert-card" key={c.title}>
                  <svg
                    className="cert-card__icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="3"
                      y="4"
                      width="18"
                      height="14"
                      rx="1.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                    />
                    <path
                      d="M6.5 8h11M6.5 11h11M6.5 14h6"
                      stroke="currentColor"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                    />
                    <circle
                      cx="12"
                      cy="19.5"
                      r="2.2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.3"
                    />
                  </svg>
                  <p className="cert-card__title">{c.title}</p>
                  <p className="cert-card__year">{c.year}</p>
                </div>
              ))}
            </div>
            <a href="#" className="panel__link">
              View All Certificates
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* ===== GALLERY ===== */}
      <section className="gallery">
        <p className="eyebrow">Moments That Define Our Journey</p>
        <div className="gallery__grid">
          {moments.map((m) => (
            <figure className="gallery__item" key={m.caption}>
              {/* <img src={m.src} alt={m.caption} /> */}
              <figcaption>{m.caption}</figcaption>
            </figure>
          ))}
        </div>
      </section>

      {/* ===== VISION / MISSION / VALUES ===== */}
      <section className="vmv">
        <div className="vmv__grid">
          <div className="vmv__item">
            <span className="vmv__icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
              </svg>
            </span>
            <div>
              <h3 className="vmv__title">Our Vision</h3>
              <p className="vmv__text">
               To nurture a winning network by building bonds for long-term value in the value chain.
              </p>
            </div>
          </div>

          <div className="vmv__item">
            <span className="vmv__icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
                <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="1.6" />
                <circle cx="12" cy="12" r="1.4" fill="currentColor" />
              </svg>
            </span>
            <div>
              <h3 className="vmv__title">Our Mission</h3>
              <p className="vmv__text">
               To enhance, empower and connect through technology to create worth and make a distinction.
              </p>
            </div>
          </div>

          <div className="vmv__item">
            <span className="vmv__icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m12 2 3.5 5.5L21 9l-4 4.5L18 20l-6-3.5L6 20l1-6.5L3 9l5.5-1.5L12 2Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <div>
              <h3 className="vmv__title">Our Values</h3>
              <ul className="vmv__list">
                <li>Integrity</li>
                <li>Innovation</li>
                <li>Collaboration</li>
                <li>Excellence</li>
                <li>Impact</li>
              </ul>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}